import { render, staticRenderFns } from "./CardBlogBiblioteca.vue?vue&type=template&id=6e164065&scoped=true&"
import script from "./CardBlogBiblioteca.vue?vue&type=script&lang=js&"
export * from "./CardBlogBiblioteca.vue?vue&type=script&lang=js&"
import style0 from "./CardBlogBiblioteca.vue?vue&type=style&index=0&id=6e164065&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e164065",
  null
  
)

export default component.exports